import { ProgramType } from './ProgramList.types';

export const tabsOrder = [
  ProgramType.IndividualCoachHubFramework,
  ProgramType.StandaloneAI,
  ProgramType.IndividualHolisticFramework,
  ProgramType.Collective,
];
